document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.swiper', {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        autoplay: {
            delay: 3000
        },
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 40
            }
        },
        on: {
            slideChange: function () {
                updateBulletColors();
            }
        }
    });

    function updateBulletColors() {
        const swiperPaginationBullets = document.querySelectorAll(
            '.swiper-pagination-bullet'
        );
        swiperPaginationBullets.forEach((bullet) => {
            bullet.style.backgroundColor = '#041C2C';
        });

        const activeBullet = document.querySelector(
            '.swiper-pagination-bullet-active'
        );
        if (activeBullet) {
            activeBullet.style.backgroundColor = '#AC3B72';
        }
    }

    updateBulletColors();
});
